import { schedularTherapistFilterAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  loading: false,
};

export const maintainTherapistsFilterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }
    case schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }
    case schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
